export const RADIUS_SM = '0.25rem';
export const RADIUS_MD = '0.5rem';
export const RADIUS_LG = '1rem';
export const RADIUS_XL = '1.5rem';
export const RADIUS_2XL = '22.5rem';
